/**
 * @generated
 * @file InputText (generated by DevLink)
 *
 * This file is generated by DevLink from a Webflow component. Manual edits are discouraged.
 *
 * @see {@link https://ticketing-2-0.design.webflow.com | Source site in Webflow}
 */
"use client";

import { DEVLINK_SCOPE_CLASS } from "./devlinkScope";
import Block from "./webflow_modules/Basic/components/Block";
import FormBlockLabel from "./webflow_modules/Form/components/FormBlockLabel";
import FormTextInput from "./webflow_modules/Form/components/FormTextInput";

/**
 * Props for {@link InputText}
 */
export type InputTextProps = {
  helperText?: React.ReactNode;
  inputRuntimeProps?: Record<string, unknown>;
  label?: React.ReactNode;
  visibility?: boolean;
};

/**
 * InputText
 *
 * @see {@link https://ticketing-2-0.design.webflow.com | Source site in Webflow}
 */
export function InputText({
  helperText = "Helper - Text",
  inputRuntimeProps = {},
  label = "Label - Text",
  visibility = false,
}: InputTextProps) {
  return (
    <div
      className={DEVLINK_SCOPE_CLASS}
      style={{
        display: "contents",
      }}
    >
      <Block className={"input"} tag={"div"}>
        <FormBlockLabel className={"label"} htmlFor={"name"}>
          {label}
        </FormBlockLabel>
        {visibility ? (
          <FormBlockLabel
            className={"text-size-small text-color-graydark"}
            htmlFor={"name"}
          >
            {helperText}
          </FormBlockLabel>
        ) : null}
        <FormTextInput
          autoFocus={false}
          className={"input-field"}
          data-name={"Name"}
          disabled={false}
          id={"name"}
          maxLength={256}
          name={"name"}
          placeholder={"Placeholder"}
          required={false}
          type={"text"}
          {...inputRuntimeProps}
        />
      </Block>
    </div>
  );
}
